export default "__VITE_ASSET__CdtCYzSQ__"